
import React, { useState, useEffect, useRef } from "react";
import axios from "axios";
// import "./housemaamaas.css";
// import "./Style.css";




const SidescrollAdvertisements = () => {
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);
  const [coupons, setCoupons] = useState([]);
  const [isHovered, setIsHovered] = useState(false);
  const scrollRef = useRef(null);
  const scrollIntervalRef = useRef(null);

  // Handle mobile resize
  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth <= 768);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  // Convert API image into proper URL
  // Convert API image into proper URL
  // Convert API image into proper URL
  // Convert API image into proper URL
  const toImageSrc = (raw) => {
    if (!raw || raw.trim() === "" || raw.trim() === "/") return "/placeholder.svg";

    // Check if it's already a data URL
    if (raw.startsWith('data:image/')) {
      return raw;
    }

    // Check if it's a full URL
    if (/^https?:\/\//i.test(raw)) return raw;

    // If it's base64 data without prefix, add the PNG prefix (assuming PNG format)
    // You can change 'png' to 'jpeg' or 'jpg' if needed
    if (raw.length > 1000 && /^[A-Za-z0-9+/=]/.test(raw)) {
      return `data:image/png;base64,${raw}`;
    }

    // Otherwise, assume it's a relative path
    return ` https://backend.maamaas.com/food/api/${raw}`;
  };

  // Fetch Coupons with Auth Token
  useEffect(() => {
    const vendorId = localStorage.getItem("vendorId") || 1;
    const token = localStorage.getItem("authToken"); // get token from localStorage
    const userId = localStorage.getItem("userId");

    axios
      .get(
        ` https://backend.maamaas.com/food/api/coupon/user/${userId}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      )
      .then((res) => {
        console.log("Coupons API Response:", res.data); // Debug

        // Determine if data is directly array or wrapped
        const couponsArray = Array.isArray(res.data)
          ? res.data
          : Array.isArray(res.data.data)
            ? res.data.data
            : [];

        const couponsWithImages = couponsArray.map((coupon) => {
          const imageSrc = toImageSrc(coupon.image || coupon.imageUrl);

          console.log("🔍 Coupon Debug:", {
            id: coupon.id,
            code: coupon.code,
            rawImage: coupon.image,
            imageType: typeof coupon.image,
            imageLength: coupon.image ? coupon.image.length : 0,
            imageStartsWith: coupon.image ? coupon.image.substring(0, 50) : "empty",
            finalImageSrc: imageSrc
          });

          return {
            ...coupon,
            image: imageSrc,
          };
        });

        setCoupons(couponsWithImages);
      })
      .catch((err) => {
        console.error("Error fetching coupons:", err);
      });
  }, []);

  // Auto scroll logic
  useEffect(() => {
    const startAutoScroll = () => {
      if (scrollRef.current && !scrollIntervalRef.current) {
        scrollIntervalRef.current = setInterval(() => {
          if (scrollRef.current && !isHovered) {
            const el = scrollRef.current;
            el.scrollTop += 1;
            if (el.scrollTop + el.clientHeight >= el.scrollHeight) {
              el.scrollTop = 0;
            }
          }
        }, 30);
      }
    };

    const stopAutoScroll = () => {
      if (scrollIntervalRef.current) {
        clearInterval(scrollIntervalRef.current);
        scrollIntervalRef.current = null;
      }
    };

    startAutoScroll();
    return stopAutoScroll;
  }, [isHovered]);

  return (
    <div className="container-fluid">
      <div className="row ms-0">
        <div className="col-lg-3" style={{ display: isMobile ? "none" : "block" }}>
          <div
            style={{
              position: "fixed",
              right: "16px",
              top: "40px",
              borderRadius: "8px",
              padding: "10px",
              marginTop: "40px",
            }}
            className="scroll-fixed-data mobilescroll"
          >
            <div
              ref={scrollRef}
              style={{
                maxHeight: "700px",
                overflowY: "auto",
                paddingRight: "5px",
                scrollbarWidth: "none",
                msOverflowStyle: "none",
                marginTop: "40px",
              }}
              className="hide-scrollbar"
              onMouseEnter={() => setIsHovered(true)}
              onMouseLeave={() => setIsHovered(false)}
            >
              {coupons.length > 0 ? (
                coupons.map((coupon, index) => (
                  <div
                    key={`${coupon.id}-${index}`}
                    className="card scroll-data-responsive"
                    style={{
                      width: "18vw",
                      height: "150px",
                      marginBottom: "10px",
                      backgroundColor: "rgba(240, 240, 240, 0.3)",
                      backgroundImage: `url(${coupon.image})`,
                      backgroundSize: "cover",
                      backgroundPosition: "center",
                      borderRadius: "8px",
                      boxShadow: "0px 2px 4px rgba(0,0,0,0.1)",
                      // padding: "10px",
                      position: "relative",
                    }}
                  >
                    <div
                      style={{
                        borderRadius: "8px",
                        padding: "0px",
                        height: "100%",
                        display: "flex",
                        flexDirection: "column",
                        justifyContent: "center",
                        alignItems: "center",
                        background: "rgba(0,0,0,0.4)",
                      }}
                    >
                      <h5 style={{ margin: 0, color: "#ffffffff", fontWeight: "bold" }}>
                        Code: {coupon.code}
                      </h5>
                      <p style={{ margin: 0, color: "#ffffffff", fontSize: "18px", fontWeight: "bold" }}>
                        {coupon.discountPercentage}% OFF
                      </p>
                    </div>
                  </div>
                ))
              ) : (
                <p style={{ color: "#777", textAlign: "center" }}>
                  No active coupons available
                </p>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SidescrollAdvertisements;
